import {Controller} from "@hotwired/stimulus"
import Sortable from "sortablejs"
import Rails from '@rails/ujs';

export default class extends Controller {
  static targets = ['row', 'parent'];

  parentTargetConnected(element) {
    Sortable.create(element, {
      group: element.dataset.type,
      animation: 150,
      multiDrag: true,
      selectedClass: 'bg-orange-300 selected',
      ghostClass: 'bg-orange-100',
      fallbackTolerance: 3,
      onEnd: this.end.bind(this)
    })

  }

  end(event) {
    if (event.from == event.to){
      this.prioritize(event);
    } else {
      let data = new FormData();
      let parent = event.item.parentNode.dataset.swimlane;
      if (parent) {
        data.append(`parent_readable_id`, parent);
      }

      const that = this;
      Rails.ajax({
        url: event.item.dataset.url,
        type: 'PATCH',
        data: data,
        success: function(data) { that.prioritize(event); },
        error: function(data) { event.from.insertBefore(event.item, event.from.children[event.oldIndex]); }
      })
    }
  }

  prioritize(event) {
    let data = new FormData();
    const newPosition = event.newIndex;
    data.append(`${event.item.dataset.type}[entry_attributes][id]`, event.item.dataset.id);
    data.append(`${event.item.dataset.type}[entry_attributes][gantt_position_position]`, newPosition);
    Rails.ajax({
      url: event.item.dataset.url,
      headers: {
        "Accept": "text/vnd.turbo-stream.html, text/html, application/xhtml+xml",
      },
      type: 'PATCH',
      data: data,
      success: function(data) {},
      error: function(data) { event.from.insertBefore(event.item, event.from.children[event.oldIndex]); }
    })
  }
}
